export default __webpack_public_path__ + "static/media/HeinekenSerif18-Regular.63234e7d.ttf";